<template>
  <v-app>
    <v-overlay class="loading_bg text-center" opacity="0">
      <v-progress-circular v-show="valid == null" indeterminate size="64" color="blue"></v-progress-circular>
      <v-btn v-if="valid == false" class="pa-12" outlined large fab color="red" elevation="0">
        <v-icon size="72">mdi-account-multiple-remove-outline</v-icon>
      </v-btn>
      <v-btn v-if="valid == true" class="pa-12" outlined large fab color="green" elevation="0">
        <v-icon size="72">mdi-account-multiple-check-outline</v-icon>
      </v-btn>
      <div class="mt-6 font-weight-black title black--text" :class="valid == false ? 'red--text' : ''">{{ note }}</div>
    </v-overlay>
    <wtk-message><!--弹出消息区域--></wtk-message>
  </v-app>
</template>
<script>
import Storage from "@/commons/storage";
export default {
  name: "App",
  data: () => ({ valid: null, note: "授权登录中..." }),
  mounted() {
    //授权用户登录
    //1.获取用户令牌
    var token = this.GetQueryString("stoken");
    if (!token || token == "") {
      this.valid = false;
      this.note = "授权登录错误，用户令牌不能为空，请关闭页面后重试！";
      return;
    }
    Storage.set("_wit_acis_token", token);
    //2.跳转系统首页（加延时跳转）
    // setTimeout(() => {
    //   window.document.location.href = "/#/home";
    // }, 500);
    this.$router.push("/home");
  },
  methods: {
    GetQueryString(name) {
      var reg = new RegExp("[?&]" + name + "=([^&^#^/]*)", "i");
      var res = window.location.href.match(reg);
      return res != null ? unescape(res[1]) : "";
    },
  },
};
</script>
<style>
.loading_bg {
  background-image: url("../../assets/jz.jpg") !important;
  background-size: cover;
}
</style>